import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { RekbotsService } from '../services/rekbots.service';
import { Rekbot } from '../models/rekbot.model';
import { combineLatest, forkJoin, tap } from 'rxjs';
import { RekbotSettings } from '../models/rekbot-settings.model';

export const rekbotResolver: ResolveFn<{rekbot_res: Rekbot; settings_res: RekbotSettings}> = (route, state) => {
  console.log("Resolve uruchomiony");
  
  const rekbotsService = inject(RekbotsService);
  const rekbotId = Number(route.paramMap.get('rekbotId')!);
  // return rekbotsService.fetchRekbot(rekbotId);
  // return forkJoin({
  //   rekbot: rekbotsService.fetchRekbot(rekbotId),
  //   map: rekbotsService.fetchMap(rekbotId),
  // }); 
  return combineLatest({
    rekbot_res: rekbotsService.fetchRekbot(rekbotId),
    settings_res: rekbotsService.fetchRekbotSettings(rekbotId),
  })
  // .pipe(
  //   tap(data => console.log('Resolver emission:', data))
  // );
};
